/**
 * Return Lose Types
 * 
 * Types สำหรับระบบคืนยอดเสีย
 */

// ประเภทเกมที่รองรับ (ทั้งหมด 24 เกม)
export const GAME_GROUPS = [
  // เกมพื้นฐาน (14 เกม)
  { value: 'hdp', label: 'HDP (แฮนดิแคป)' },
  { value: 'mixParlay', label: 'Mix Parlay' },
  { value: 'mixStep', label: 'Mix Step' },
  { value: 'casino', label: 'คาสิโน' },
  { value: 'slot', label: 'สล็อต' },
  { value: 'card', label: 'ไพ่' },
  { value: 'lotto', label: 'หวย' },
  { value: 'keno', label: 'คีโน่' },
  { value: 'trade', label: 'เทรด' },
  { value: 'poker', label: 'โป๊กเกอร์' },
  { value: 'esport', label: 'อีสปอร์ต' },
  { value: 'cock', label: 'ไก่ชน' },
  { value: 'saba', label: 'SABA' },
  { value: 'sbo', label: 'SBO' },
  // เกมเพิ่มเติม (10 เกม)
  { value: 'dbs', label: 'DBS' },
  { value: 'fbs', label: 'FBS' },
  { value: 'plb', label: 'PLB' },
  { value: 'umb', label: 'UMB' },
  { value: 'vsb', label: 'VSB' },
  { value: 'afb', label: 'AFB' },
  { value: 'lali', label: 'LALI' },
  { value: 'm8', label: 'M8' },
  { value: 'ufa', label: 'UFA' },
  { value: 'obx', label: 'OBX' },
] as const

export type GameGroup = typeof GAME_GROUPS[number]['value']

// สถานะของ ReturnLose
export enum ReturnLoseStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

// สถานะการคืนยอด (ReturnLoseLog)
export enum ReturnStatus {
  WAITING = 0,
  SUCCESS = 1,
  FAILED = 2,
}

// Interface สำหรับ ReturnLose (รายการคืนยอดเสีย)
export interface ReturnLose {
  id: string
  objectId: string
  uuid: string
  
  // การตั้งค่า
  game_group: string[] // กลุ่มเกม (multiple)
  start_date: Date
  end_date: Date
  date_return?: string // วันที่คืนยอดเสีย (display format)
  amount_lose: number // ยอดเสียขั้นต่ำ
  percent_return: number // เปอร์เซ็นต์คืน
  
  // ตัวเลือก
  after_bonus: boolean // หักโบนัสก่อนคืน
  return_bonus: boolean // คืนเป็นโบนัส
  return_bonus_turnover: number // Turn Over (X)
  
  // สถิติ
  member_count: number // จำนวนสมาชิก
  amount_count: number // ยอดเสียทั้งหมด
  amount_after_bonus_count: number // ยอดเสียหลังหักโบนัส
  amount_return_count: number // ยอดที่คืนจริง
  return_success_count: number // คืนสำเร็จ
  return_fail_count: number // คืนไม่สำเร็จ
  
  // สถานะ
  status: ReturnLoseStatus
  
  // ข้อมูลผู้สร้าง
  user_created_id?: {
    objectId: string
    firstname?: string
    lastname?: string
    username?: string
  }
  user_updated_id?: {
    objectId: string
    firstname?: string
    lastname?: string
    username?: string
  }
  
  createdAt: string
  updatedAt: string
}

// Interface สำหรับ ReturnLoseLog (ผลการคำนวณรายบุคคล)
export interface ReturnLoseLog {
  id: string
  objectId: string
  uuid: string
  
  // Reference
  return_lose_obj?: {
    objectId: string
    game_group: string[]
    date_return?: string
    amount_lose: number
    percent_return: number
  }
  
  // สมาชิก
  member_id?: {
    objectId: string
    agent_username?: string
    firstname?: string
    lastname?: string
    username?: string
  }
  
  // ยอดเงิน
  amount_count: number // ยอด แพ้/ชนะ
  amount_bonus: number // โบนัส
  amount_after_bonus_count: number // แพ้/ชนะ หลังหักโบนัส
  amount_return_count: number // ยอดคืน
  
  // การคืนยอด
  return_to_member: boolean // เลือกคืนให้สมาชิก
  return_status: ReturnStatus // สถานะการคืน
  
  // ข้อมูลผู้สร้าง
  user_created_id?: {
    objectId: string
    firstname?: string
    lastname?: string
    username?: string
  }
  
  createdAt: string
  updatedAt: string
}

// Query params สำหรับ ReturnLose
export interface ReturnLoseQueryParams {
  query?: string
  status?: ReturnLoseStatus
  page?: number
  limit?: number
  sort?: {
    field: string
    direction: 'asc' | 'desc'
  }
}

// Query params สำหรับ ReturnLoseLog
export interface ReturnLoseLogQueryParams {
  uuid: string // filter by uuid
  query?: string
  return_status?: ReturnStatus
  page?: number
  limit?: number
}

// Form data สำหรับสร้าง ReturnLose
export interface CreateReturnLoseData {
  game_group: string[]
  start_date: Date
  end_date: Date
  amount_lose: number
  percent_return: number
  after_bonus?: boolean
  return_bonus?: boolean
  return_bonus_turnover?: number
  notify_member?: boolean  // แจ้งเตือนสมาชิกเมื่อคืนยอดสำเร็จ
}

// สถิติสรุป
export interface ReturnLoseStats {
  total: number
  pending: number
  approved: number
  rejected: number
  totalReturned: number
}

export interface ReturnLoseLogStats {
  total: number
  waiting: number
  success: number
  failed: number
  totalAmount: number
}









